// @LTG-ID: data-levers
// @STATUS: BUILT @SHARED
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-011, source Landing Page.html lines 2463-2474
// @CHANGED: 2026-02 session_003 (CHG-0040)
// @OWNER: web
//
// 10 value-lever cards consumed by F-011 Levers. Industry-median scores (0–100)
// are illustrative defaults from source. The full assessment (Strategic Snapshot
// product) scores against ~3,400 owner-operated peers — that real score lands
// on app.letstalkgrowth.com, not here.

export const LEVERS = [
    {
        title: "Profit Power",
        val: 78,
        desc: "Gross & operating margin discipline vs. industry median. Every point above peers is a multiple-expander at exit.",
    },
    {
        title: "Future Upside",
        val: 64,
        desc: "Recurring revenue, pipeline coverage, addressable-market trajectory. Buyers underwrite the next 3 years, not the last.",
    },
    {
        title: "Risk Shield",
        val: 52,
        desc: "Concentration risk: customers, suppliers, key personnel, geography. The first thing diligence picks apart.",
    },
    {
        title: "Value Leverage",
        val: 71,
        desc: "Pricing power, gross-margin floor, and your ability to raise rates without losing volume.",
    },
    {
        title: "Revenue Reliability",
        val: 83,
        desc: "Contracted vs. transactional mix. Churn cohorts. Net revenue retention. The single biggest multiple-mover.",
    },
    {
        title: "Competitive Advantage",
        val: 67,
        desc: "Moats that actually defend: brand, switching costs, regulatory positioning, network effects, scale economies.",
    },
    {
        title: "Client Loyalty",
        val: 74,
        desc: "NPS, repeat-purchase rate, average client tenure. Stickiness compounds, and gets paid for.",
    },
    {
        title: "Delegation Index",
        val: 48,
        desc: "How long the business runs without you. The number a strategic buyer cares about more than any other.",
    },
    {
        title: "Sustainability Impact",
        val: 59,
        desc: "ESG posture, energy intensity, supplier-chain provenance. Increasingly material to institutional acquirers.",
    },
    {
        title: "Digital Transformation",
        val: 56,
        desc: "Tech stack maturity, data integrity, automation coverage. Where most lower-middle-market firms quietly bleed margin.",
    },
];
